import { BoxLeadDraftEntity } from "@modules/boxLead/entities/boxLeadInput"
import { BoxLeadInputKey } from "@modules/boxLead/formik/boxLeadFormik"
import { BoxStaffStatus } from "@modules/boxStaff/gateway/boxStaffDto"
import { word } from "@modules/core/utils/i18n"
import { SearchStaffInput } from "@modules/formik/components/searchStaffInput"
import { SearchStaffInputSkeleton } from "@modules/formik/components/searchStaffInputSkeleton"
import { HUButton } from "@modules/ui/components/huButton"
import { SimpleFormik } from "@src/typings/formik"
import { Suspense } from "react"

export type BoxLeadFormStepOneProps = {
  handleSubmit: () => void
  onPrevious: () => void
  formik: SimpleFormik<BoxLeadDraftEntity, BoxLeadInputKey>
  isFormFieldInValid: (name: BoxLeadInputKey) => boolean
  getFormErrorMessage: (name: BoxLeadInputKey, errorMessage?: string) => React.JSX.Element | undefined
  disabled: boolean
}

export function BoxLeadFormStepOne({
  handleSubmit,
  onPrevious,
  formik,
  isFormFieldInValid,
  getFormErrorMessage,
  disabled,
  className,
  ...props
}: BoxLeadFormStepOneProps & React.ComponentProps<"div">) {
  const defaultClassName = "flex flex-column gap-5"

  return (
    <div className={className ?? defaultClassName} {...props}>
      <Suspense
        fallback={
          <SearchStaffInputSkeleton label={word("box.lead.form.input.madeByStaffId.label")} isRequiredInput={true} />
        }
      >
        <SearchStaffInput
          label={word("box.lead.form.input.madeByStaffId.label")}
          name="madeByStaffId"
          isRequiredInput={false}
          isInvalid={isFormFieldInValid("madeByStaffId")}
          setFieldValue={formik.setFieldValue}
          getFieldProps={formik.getFieldProps}
          error={getFormErrorMessage("madeByStaffId")}
          filterByStatus={[BoxStaffStatus.ACCEPTED]}
        />
      </Suspense>

      <div className=" mb-4 flex flex-row gap-2 align-items-center justify-content-center">
        <HUButton
          type="Left_Icon"
          size="M"
          colorType="Quaternary"
          text={word("global.cancel")}
          onClick={onPrevious}
          className="w-full"
        />
        <HUButton
          type="Right_Icon"
          size="M"
          colorType="Primary"
          text={word("global.continue")}
          onClick={handleSubmit}
          disabled={disabled}
          submit
          className="w-full"
        />
      </div>
    </div>
  )
}
